module.exports = __webpack_public_path__ + "img/ltu.c3aeac0d.svg";